// src/store/theme.js
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useThemeStore = defineStore('theme', () => {
    // State
    const theme = ref(localStorage.getItem('theme') || 'system')
    const isDark = ref(false)

    // Methods
    const updateTheme = () => {
        const root = window.document.documentElement

        // Determine if we should use dark mode
        if (theme.value === 'dark' || (theme.value === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            root.classList.add('dark')
            isDark.value = true
        } else {
            root.classList.remove('dark')
            isDark.value = false
        }

        localStorage.setItem('theme', theme.value)
    }

    const setTheme = (newTheme) => {
        theme.value = newTheme
        updateTheme()
    }

    const toggleTheme = () => {
        setTheme(isDark.value ? 'light' : 'dark')
    }

    const initTheme = () => {
        updateTheme()

        // Listen for system theme changes
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
            if (theme.value === 'system') {
                updateTheme()
            }
        })
    }

    return {
        theme,
        isDark,
        setTheme,
        toggleTheme,
        initTheme
    }
})
